<template>
  <div class="info">
    <Head :title="$ml.get(`General Information`)"/>
    <div>
      <!-- TO DO: повстовлять функции для текста -->
      <app-text-input
        :label="$ml.get(`Name`)"
        v-model="info.name"
        type="text"
        required
      />
      <app-text-input
        :label="$ml.get(`Country`)"
        v-model="info.country"
        type="text"
        required
      />
      <app-text-input
        :label="$ml.get(`Phone`)"
        v-model="info.phone"
        type="number"
      />
      <app-text-input
        :label="$ml.get(`Address`)"
        v-model="info.address"
        type="text"
      />
      <app-text-input
        :label="$ml.get(`Remarks`)"
        v-model="info.remarks"
        type="text"
      />
      <app-btn
        @click="save()"
        class="saveBtn"
      >
        {{$ml.get(`save`)}}
      </app-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Head from './helps/Head.vue'

export default {
  props: {
    info: Object
  },
  components: {
    Head
  },
  methods: {
    save () {
      this.$store.dispatch('labs/popup/save').then(res => {
        this.$notify({
          group: 'notices',
          title: `Lab successfully added!`,
          type : 'Success',
        });
      }).catch(error => {
          this.$notify({
              group: 'notices',
              title: this.$ml.get(error.message),
              type : 'error',
            });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  .info {
    width: 100%;

    > div {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;

      &:nth-child(2) {
        margin-top: 25px;

        @media (max-width: 768px) {
          justify-content: center;
        }
      }

      > div, button {
        width: calc(33.3% - 30px);
        min-width: 200px;
        margin: 15px;
        padding: 1px;
      }
    }
  }
</style>
